export function formatChartPercent(value: number): string {
  return `${Math.floor(value)}%`;
}
